var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9118_5822)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9118_5822",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9118_5822)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9118_5822",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9118_5822)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9118_5822",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9118_5822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9118_5822)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9118_5822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8571 12.9904C13.8571 14.0167 13.0263 14.8475 12 14.8475C10.9737 14.8475 10.1429 14.0167 10.1429 12.9904C10.1429 11.9641 10.9737 11.1333 12 11.1333C13.0263 11.1333 13.8571 11.9641 13.8571 12.9904ZM17.6575 8.33616C18.3992 8.33616 19 8.93698 19 9.67867V13.1974V16.1813C19 16.9719 18.3589 17.613 17.5684 17.613H6.43162C5.64107 17.613 5 16.9719 5 16.1813V13.1945V9.67867C5 8.93698 5.60082 8.33616 6.34251 8.33616H9.02752L9.154 7.80146C9.34661 6.97353 10.0854 6.38708 10.9363 6.38708H13.0665C13.9175 6.38708 14.6563 6.97353 14.8489 7.80146L14.9725 8.33616H17.6575ZM7.8 10.2737C7.8 9.9029 7.49815 9.60105 7.12731 9.60105C6.75359 9.60105 6.45175 9.9029 6.45175 10.2737C6.45175 10.6446 6.75359 10.9464 7.12444 10.9464C7.49815 10.9493 7.8 10.6475 7.8 10.2737ZM15.3117 12.9904C15.3117 11.162 13.8283 9.67867 12 9.67867C10.1717 9.67867 8.6883 11.162 8.6883 12.9904C8.6883 14.8187 10.1717 16.3021 12 16.3021C13.8283 16.3021 15.3117 14.8187 15.3117 12.9904Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9118_5822",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9118_5822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9118_5822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.854af908f35d8960c0a31e752eb6c923.svg";
export { ForwardRef as ReactComponent };